import WebServiceRequest from "../../../Api/WebServiceRequest";

class VirtualCategoriesGetAll extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VirtualCategory/GetAll");
  }
}
export default VirtualCategoriesGetAll;
